import { signal } from '@preact/signals-react'
import type { User } from './types'

export const ROLES = __OIDC_ROLES__
export const userProfile = signal<User<Role> | null>(null)

export const MOCK_USER = {
  id: 'mockid',
  name: 'amock',
  givenName: 'Alois',
  familyName: 'Mock',
  email: 'Alois.Mock@mock.at',
  roles: __MOCK_ROLES__,
  token: 'ignoreme'
} as User<Role>

export default userProfile
